import { Router } from '@angular/router';
import { Delivery } from './../shared/order/delivery';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'osca-delivery',
  templateUrl: './delivery.component.html',
  styles: []
})
export class DeliveryComponent implements OnInit {
  @Input() deliveryList: Delivery[];
  @Input() counter: number;

  constructor(private router: Router) { }

  ngOnInit() {
  }

}
